export default "__VITE_ASSET__4136b18a__"